import MainHeader from '../../components/MainHeader'
import MainFooter from '../../components/MainFooter'
import CTAButton from '../../components/CTAButton'

import './PageConstruction.css'
import './MPageConstruction.css'

import { lP } from '../../core.js'

import construction_img from '../../assets/pictures/sectionimages/construction-oBG.webp'


export default function PageConstruction() {

    return (
        <div className='mainCon' id='mainCon'>
            <MainHeader selectedsite={""} disableanimation={false} />

            <section className='sec_start' id='sec_start--pageconstruction'>

                <h1>🚧 Baustelle betreten verboten! 🚧</h1>
                <h2>Diese Seite wird gerade überarbeitet<br />
                    und steht in Kürze wieder zur Verfügung.</h2>
                <div className='infocontainer'>
                    <p>
                        Wir bitten um Entschuldigung!<br />
                        Kehre entweder zur vorherigen Seite oder zur <a href="/">Startseite</a> zurück.<br />
                        <br />
                        Bei Fragen erreichst du uns uns über unseren Kontaktbereich<br />
                        oder alternativ per Mail an <a href="mailto:hey@tonetwork.de">hey@tonetwork.de</a>.<br />
                    </p>
                </div>
                <br />
                <img src={construction_img} alt={"Baustelle mit Arbeiter und Kran"} className='construction_img' />
            </section>
            <MainFooter />
        </div>
    )
}